import Config from '../../config';
import { QueryKeys, useCustomQuery } from './index';
import { CustomGroup, CustomGroupWithCompanyCodes } from '../types/customGroup';

export const useCustomGroups = () => useCustomQuery<CustomGroup[]>(
  [QueryKeys.customGroups.CustomGroups],
  {
    url: Config.endpoints.FETCH_CUSTOM_GROUPS,
    errorMessage: 'Fetching Custom Groups failed',
    defaultData: [],
  });

export const useCustomGroupsWithCompanyCodes = ({ periodName }: { periodName?: string }) =>
  useCustomQuery<CustomGroupWithCompanyCodes[]>(
    [QueryKeys.customGroups.CustomGroupsWithCompanyCodes],
    {
      url: Config.endpoints.FETCH_CUSTOM_GROUPS_WITH_COMPANY_CODES
        .replace(/:periodName/, periodName ?? ''),
      errorMessage: 'Fetching Custom Groups with company codes failed',
      defaultData: [],
      enabled: !!periodName,
    }
  );
